const initMarketpriceState = {
  brand: null,
  series: null,
  type: null,
  cylinder: null,
  period: null,
  model: null,
  grade: null,
  transmission: null,
  startYear: null,
  endYear: null,
  color: null,
  Kepemilikan: null,
  city: null,
  location: null,
  stnk: null,
  platNo: null,
  bpkb: null,
  page: 1,
  perPage: 10,
  data: null,
  total_data: 0,
  message: '',
  loading: false,
  error: false,
  error_code: null,
  success: false,
};

export const marketpriceReducer = (state = initMarketpriceState, action) => {
  if (action.type === 'SET_SELECTED_MARKETPRICE') {
    return {
      ...state,
      ...action.value,
    };
  }
  if (action.type === 'GET_MARKETPRICE_START') {
    return {
      ...state,
      loading: true,
      error: false,
      success: false,
    };
  }
  if (action.type === 'GET_MARKETPRICE_SUCCESS') {
    return {
      ...state,
      loading: false,
      success: true,
      ...action.payload,
    };
  }
  if (action.type === 'GET_MARKETPRICE_FAILURE') {
    return {
      ...state,
      loading: false,
      error: true,
      error_code: action.payload.error_code,
      message: action.payload.message,
    };
  }

  if (action.type === 'NULLIFY') {
    return initMarketpriceState;
  }

  return state;
};
